import { render, staticRenderFns } from "./SemesterHistory.vue?vue&type=template&id=ac42dee8&"
import script from "./SemesterHistory.vue?vue&type=script&lang=js&"
export * from "./SemesterHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports